import { render, staticRenderFns } from "./AdminOrganizations.vue?vue&type=template&id=2aa33ba4&scoped=true&"
import script from "./AdminOrganizations.vue?vue&type=script&lang=js&"
export * from "./AdminOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa33ba4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa33ba4')) {
      api.createRecord('2aa33ba4', component.options)
    } else {
      api.reload('2aa33ba4', component.options)
    }
    module.hot.accept("./AdminOrganizations.vue?vue&type=template&id=2aa33ba4&scoped=true&", function () {
      api.rerender('2aa33ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/AdminPage/AdminOrganizations.vue"
export default component.exports